import {Component, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{
  title = 'app';

  constructor(private router: Router, private translate: TranslateService) {
    this.router.events.subscribe(
      () => window.scrollTo(0, 0)
    );
  }

  ngOnInit() {
    this.translate.use('zh-cn');
  }

  useLanguage(lang) {
    this.translate.use(lang);
  }
}



// WEBPACK FOOTER //
// C:/Users/anach/Desktop/tengtu-website/src/app/app.component.ts